import React from 'react';
import PropTypes from 'prop-types';
import BoxAndWhiskerDataPoint from './BoxAndWhiskerDataPoint';

class BoxAndWhiskerTooltip extends React.Component {
    static propTypes = {
        tooltipX: PropTypes.number.isRequired,
        tooltipY: PropTypes.number.isRequired,
        tooltipTriangleDirection: PropTypes.oneOf(['LEFT', 'RIGHT']).isRequired,
        tooltipFormatFunction: PropTypes.func.isRequired,
        boxAndWhiskerDataPoint: PropTypes.instanceOf(BoxAndWhiskerDataPoint).isRequired,
        boxWidth: PropTypes.number.isRequired,
        svgWindowWidth: PropTypes.number.isRequired,
    }

    _makeRow(field, leftValue, rightText, inBox) {
        const {
            tooltipFormatFunction,
        } = this.props;
        const {
            primaryColor,
        } = this.props.boxAndWhiskerDataPoint;

        return (
            <tr
                className={'box-plot-tooltip-row box-plot-tooltip-row-'+ field + (inBox ? ' box-plot-tooltip-row-in-inner-box' : ' box-plot-tooltip-row-outside-inner-box')    }
            >
                <td
                    nowrap
                    className={'box-plot-tooltip-row-left'}
                    style={{
                        textAlign: 'right',
                        position: 'relative',
                        paddingRight: '.75em',
                        whiteSpace: 'nowrap',
                    }}
                >
                    { (leftValue === null) ? "?" : tooltipFormatFunction(leftValue)}
                    { (field == 'you') &&
                        <svg
                            className={'box-plot-tooltip-circle-container'}
                            style={{
                                zIndex: 3,
                                position: 'absolute',
                                top: '0',
                                bottom: '0',
                                margin: 'auto',
                                height: '1em',
                                width: '1em',
                                right: '-.55em',
                            }}
                        >

                            <circle
                                className={'box-plot-tooltip-outer-circle'}
                                cy='50%'
                                cx='50%'
                                r='50%'
                                fill={primaryColor}
                            />
                            <circle
                                className={'box-plot-tooltip-inner-circle'}
                                cy='50%'
                                cx='50%'
                                r='25%'
                                fill='#fff'
                            />
                        </svg>
                    }
                </td>
                <td
                    nowrap
                    className={'box-plot-tooltip-row-right'}
                    style={{
                        paddingLeft: '.75em',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                    }}
                >
                        {rightText}
                </td>
            </tr>
        );
    }

    render() {
        const {
            min,
            firstQuartile,
            median,
            thirdQuartile,
            max,
            you,
            primaryColor,
        } = this.props.boxAndWhiskerDataPoint;

        const {
            tooltipX,
            tooltipY,
            tooltipTriangleDirection,
            boxWidth,
            svgWindowWidth
        } = this.props;

        return (
           <div
                className={'box-plot-tooltip box-plot-tooltip-container' + (tooltipTriangleDirection=='LEFT' ? ' box-plot-tooltip-arrow-left' : ' box-plot-tooltip-arrow-right')}
                style={{
                    position: 'absolute',
                    top: '25%',
                    left: (tooltipTriangleDirection=='LEFT' && (tooltipX + boxWidth + 'px')),
                    right: (tooltipTriangleDirection=='RIGHT' && (svgWindowWidth - tooltipX + boxWidth + 'px')),
                    zIndex: 1
                }}
            >
                        <table
                            cellSpacing='0'
                            className={'box-plot-tooltip-table'}
                            style={{borderSpacing: '0px'}}
                        >
                            <tbody>
                                { you > max && this._makeRow('you', you, 'You', false) }
                                { this._makeRow('max', max, '90th Percentile', false) }
                                { you <= max && you > thirdQuartile && this._makeRow('you', you, 'You', false) }
                                { this._makeRow('thirdQuartile', thirdQuartile, '75th Percentile', true) }
                                { you <= thirdQuartile && you > median && this._makeRow('you', you, 'You', true) }
                                { this._makeRow('median', median, 'Median', true) }
                                { you <= median && you > firstQuartile && this._makeRow('you', you, 'You', true) }
                                { this._makeRow('firstQuartile', firstQuartile, '25th Percentile', true) }
                                { you <= firstQuartile && you > min && this._makeRow('you', you, 'You', false) }
                                { this._makeRow('min', min, '10th Percentile', false) }
                                { you <= min && this._makeRow('you', you, 'You', false) }
                            </tbody>
                        </table>

            </div>
        );
    }
};

export default BoxAndWhiskerTooltip;
